export { default as ContactSection } from './ContactSection';
export { default as Divider } from './Divider';
export { default as IButton } from './IButton';
export { default as IPagination } from './IPagination';
export { default as ITypo } from './ITypo';
export { default as Partner } from './Partner';
export { default as RichTextContent } from './RichTextContent';
